<!--<div *ngIf="property?.usefulNumbers && property?.usefulNumbers.length > 0" class="mobile useful">-->
<div #mytemplate style="background-color: #fafafa">
  <app-desktop-guest-usefulnumber *ngIf="property"  [property]="property"></app-desktop-guest-usefulnumber>
</div>

